import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

export function useSiteSettings() {
  const { data, isLoading } = useQuery({ queryKey: ["settings"], queryFn: async () => (await api.get("/settings")).data, staleTime: 5 * 60 * 1000 });
  return { settings: data || {}, loading: isLoading };
}

export function useExploreLinks(links) {
  const { settings } = useSiteSettings();
  return links.filter((l) => l.to !== "/explore/themes" || settings.explore_themes);
}
